import React, { useEffect, useState, useCallback } from "react"
import axios from "axios";
import { useCollapse } from 'react-collapsed';
import { formatAmount } from '../utils'

function CollapsibleSection(props) {
  const config = {
    defaultExpanded: props.defaultExpanded || false,
    collapsedHeight: props.collapsedHeight || 0
  };
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);

  return (
    <div className="card" id={props.id}>
      <header className="card-header" {...getToggleProps()}>
        <p className="card-header-title">
          {props.title}
        </p>
        <button className="card-header-icon" aria-label="more options">
          <span className="icon">
            <i className={'fas fa-angle-' + (isExpanded ? 'up' : 'down')} aria-hidden="true"></i>
          </span>
        </button>
      </header>
      <div className="card-content" {...getCollapseProps()}>
        {props.children}
      </div>
    </div>
  );
}

const renderAccount = (source, identifier, currency) => {
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(1)

  const getTransactions = useCallback(async () => {
    axios.get(`/summary/${identifier}/transactions/${source.id}?page=${page}`)
      .then(( { data } ) => {
        setTransactions([...transactions, ...data.transactions])
        setPage(data.meta.next)
      })
      .catch(( { response } ) => {
        if (response.data?.error){
          console.log(response.data.error)
        }
      })
  })

  useEffect(() => {
    getTransactions();
  }, [])
  
  return(
    <CollapsibleSection title={source.name} defaultExpanded={false} key={source.id} id={source.id}>
      <div className="content transaction-list has-text-weight-normal">
        <table className="table">
          <thead>
            <tr>
              <th>Transaction Date</th>
              <th>Transaction Type</th>
              <th className="has-text-right">Amount</th>
              <th className="has-text-right">Balance After Transaction</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction) => (
              <tr key={transaction.id}>
                <td>{(new Date(transaction.transaction_date_timestamp * 1000)).toDateString()}</td>
                <td>{transaction.transaction_type}</td>
                <td className="has-text-right">{formatAmount(transaction.amount[currency], currency)}</td>
                <td className="has-text-right">{formatAmount(transaction.balance_after_transaction[currency], currency)}</td>
                <td>{transaction.description}</td>
              </tr>     
            ))}
          </tbody>
        </table>

        {page && <button className="button is-info" onClick={getTransactions}>Load More</button>}
      </div>
    </CollapsibleSection>
  )
}

const FundsVerificationAccountList = ({ sources, identifier, currency }) => {  
  return (
    <div className="account-list">
      {sources.map((source) => renderAccount(source, identifier, currency))}
    </div>
  );
}

export default FundsVerificationAccountList
